import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["modifier"];
import React from 'react';
import PropTypes from 'prop-types';
import { getModifiers } from '../../../../helpers';
import ListSummaryContent from './ListSummaryContent';
const ListSummary = _ref => {
  let {
      modifier
    } = _ref,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("div", {
    className: getModifiers('spec-block', modifier)
  }, /*#__PURE__*/React.createElement(ListSummaryContent, otherProps));
};
ListSummary.propTypes = {
  modifier: PropTypes.string
};
ListSummary.defaultProps = {
  modifier: ''
};
export default ListSummary;
//# sourceMappingURL=ListSummary.js.map